module.exports = __webpack_public_path__ + "img/general-english-es.81d40c19.png";